/*
 * @Author: liangen liangen@oppo.com
 * @Date: 2022-06-09 11:42:49
 * @LastEditors: liangen(80398513)
 * @LastEditTime: 2024-06-19 10:05:15
 * @FilePath: /cem-portal-frontend/src/services/survey.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios from '@/utils/request'
import axiosTip from '@/utils/axios'
import { getQueryString } from '@/utils/utils'
/*
  获取问卷列表
*/
export const getSurveyList = async (params) => {
  return axios.get('/v2/survey', { params })
}

/*
  检查问卷是否被引用
*/

export const getIsQuotedSurvey = async (id) => {
  return axios.get(`/v2/survey/${id}/check`)
}
/*
  查询国家列表
*/

export const getTopicCountries = async () => {
  return axios.get(`/v2/feedback/topic/countries`)
}

/*
  删除问卷
*/
export const deleteSurvey = async (params) => {
  return axios.delete(
    `/v2/survey/${params.id}?isDraft=${Boolean(params.isDraft)}`
  )
}

/*
复制问卷
*/
export const copySurvey = async (params) => {
  return await axios.post(`/v2/survey/${params.surveyId}/copy`, params)
}

/*
  创建问卷
*/
export const addSurveyService = async (params) => {
  return await axios.post('/v2/survey', params)
}

/*
  更新问卷
*/
export const updateSurveyService = async (params) => {
  return await axios.put(`/v2/survey/${params.surveyId}`, {
    surveyName: params.surveyName,
    surveyRemark: params.surveyRemark
  })
}

/*
  查询问卷详情
*/
export const checkSurveyDetialService = async (params) => {
  if (params.languageCode) {
    return await axios.get(
      `/v2/survey/${params.surveyId}?isDraft=${Boolean(
        params.isDraft
      )}&languageCode=${params.languageCode}`
    )
  } else {
    return await axios.get(
      `/v2/survey/${params.surveyId}?isDraft=${Boolean(params.isDraft)}`
    )
  }
}

/*
  更新问卷题目信息
*/
export const updateSurveyTopicService = async (params) => {
  return await axios.put(`/v2/survey/${params.surveyId}/topic`, params)
}

/*
  删除问卷题目
*/
export const deleteSurveyTopicService = async (params) => {
  return await axios.delete(
    `/v2/survey/${params.surveyId}/topic/${params.topicId}`
  )
}

/*
  更新问卷设置
*/
export const updateSurveySettingService = async (params) => {
  return await axios.put(`/v2/survey/${params.surveyId}/setting`, params)
}

/*
  更新题目顺序
*/
export const updateTopicOrderService = async (params) => {
  return await axios.put(
    `/v2/survey/${params.surveyId}/topic/order`,
    params.obj
  )
}

/*
  发布问卷
*/
export const publishSurveyService = async (params) => {
  return await axios.put(
    `/v2/survey/${params.surveyId}/publish?isDraft=${params.isDraft}&version=${params.version}&languageCode=${params.languageCode}`
  )
}

/*
  创建草稿
*/
export const createDraftService = async (params) => {
  return await axios.put(
    `/v2/survey/${params.surveyId}/draft?languageCode=${params.languageCode}`
  )
}

/*
添加问卷题目逻辑
*/
export const surveyTopicLogic = async (params) => {
  return await axios.post(
    `/v2/survey/${params.surveyId}/logic?isDraft=${params.isDraft}&languageCode=${params.languageCode}`,
    params.body
  )
}
/*
编辑问卷题目逻辑顺序
*/
export const surveyTopicLogicSort = async (params) => {
  return await axios.put(
    `/v2/survey/${params.surveyId}/logic/sort?isDraft=${params.isDraft}`,
    params.body
  )
}
/*
编辑问卷题目逻辑
*/
export const surveyPutTopicLogic = async (params) => {
  return await axios.put(
    `/v2/survey/${params.surveyId}/logic?isDraft=${params.isDraft}&languageCode=${params.languageCode}`,
    params.body
  )
}
/*
  查询问卷题目逻辑
*/
export const getSurveyTopicLogic = async (params) => {
  if ([undefined, ''].includes(params.languageCode)) {
    return await axios.get(
      `/v2/survey/${params.surveyId}/logic?isDraft=${params.isDraft}`
    )
  } else {
    return await axios.get(
      `/v2/survey/${params.surveyId}/logic?isDraft=${params.isDraft}&languageCode=${params.languageCode}`
    )
  }
}

/*
  删除问卷题目逻辑
*/
export const deleteSurveyTopicLogic = async (params) => {
  return await axios.delete(
    `/v2/survey/${params.surveyId}/logic/${params.logicId}?isDraft=${params.isDraft}`
  )
}

/*
  打开问卷埋点事件
*/
export const getOpenSurvey = async (params) => {
  return await axios.post(`/v2/survey/public/openSurvey`, params)
}

/*
  上传图片
*/
export async function uploadMappingFile(file) {
  console.log(file.file)
  const param = new FormData()
  // 上传文件对象 名称file与后台控制器参数要一致
  param.append('file', file.file)
  return axios({
    method: 'post',
    url: '/v2/feedback/commonApi/upload?isPublic=true',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: param
  })
}

//判断问卷选项可不可以删除
export const isDeleteOption = async (params) => {
  return await axios.get(
    `/v2/survey/${params.surveyId}/option/${params.optionId}/used`
  )
}

//外网获取问卷详情
export const getSurveyDetialByOutnet = async (params) => {
  if (params.languageCode) {
    if (params.id) {
      return await axios.get(
        `/v2/survey/public/${params.collectorPath}?triggerId=${
          params.triggerId
        }&languageCode=${params.languageCode}&instanceId=${
          params.instanceId ? params.instanceId : ''
        }&id=${encodeURIComponent(params.id)}`
      )
    } else {
      return await axios.get(
        `/v2/survey/public/${params.collectorPath}?triggerId=${
          params.triggerId
        }&languageCode=${params.languageCode}&instanceId=${
          params.instanceId ? params.instanceId : ''
        }`
      )
    }
  } else {
    if (params.id) {
      return await axios.get(
        `/v2/survey/public/${params.collectorPath}?triggerId=${
          params.triggerId
        }&instanceId=${
          params.instanceId ? params.instanceId : ''
        }&id=${encodeURIComponent(params.id)}`
      )
    } else {
      return await axios.get(
        `/v2/survey/public/${params.collectorPath}?triggerId=${
          params.triggerId
        }&instanceId=${params.instanceId ? params.instanceId : ''}`
      )
    }
  }
}

//外网获取问卷逻辑
export const getSurveyRuleByOutnet = async (params) => {
  if (params.languageCode) {
    return await axios.get(
      `/v2/survey/public/${params.collectorPath}/logic?triggerId=${params.triggerId}&languageCode=${params.languageCode}`
    )
  } else {
    return await axios.get(
      `/v2/survey/public/${params.collectorPath}/logic?triggerId=${params.triggerId}`
    )
  }
}

//提交问卷答案
export const answerSurveyService = async (params) => {
  return await axios.post(`/v2/survey/public/answer`, params)
}

//提交问卷html日志
export const submitSurveyHtmlService = async (params) => {
  return await axios.post(`/v2/survey/public/web/event/html`, params)
}

//校验问卷语言是否存在
export const querySurveyInfoExist = async (params) => {
  return await axios.post(`/v2/survey/querySurveyInfoExist`, params)
}
//校验问卷语言是否存在不用提示
export const querySurveyInfoExistIm = async (params) => {
  return await axiosTip.post(`/v2/survey/querySurveyInfoExist`, params)
}
//导出问卷
export const downloadSurveyInfo = async (params) => {
  return await axiosTip.post(`/v2/survey/downloadSurveyInfo`, params, {
    responseType: 'blob'
  })
}
//导入问卷
export const uploadSurveyInfo = async (params) => {
  return axios({
    method: 'post',
    url: `/v2/feedback/editSurveyImport/uploadSurveyInfo`,
    headers: { 'Content-Type': 'multipart/form-data' },
    data: params.file
  })
}
//问卷有多少种语言
export const querySurveyLanguageList = async (params) => {
  return await axios.get(`/v2/survey/querySurveyLanguageList`, { params })
}
//问卷有多少种语言(外网)
export const querySurveyLanguageListByOutnet = async (params) => {
  if (params.languageCode) {
    return await axios.get(
      `/v2/survey/public/${
        params.collectorPath
      }/querySurveyLanguageList?triggerId=${params.triggerId}&languageCode=${
        params.languageCode
      }&feedbackId=${params?.feedbackId ?? 0}`
    )
  } else {
    return await axios.get(
      `/v2/survey/public/${
        params.collectorPath
      }/querySurveyLanguageList?triggerId=${params.triggerId}&feedbackId=${
        params?.feedbackId ?? 0
      }`
    )
  }
}
//电子邮件退订
export const unsubscribe = async (params) => {
  return await axios.post(`/v2/survey/public/email/unsubscribe`, params)
}

//查询问卷是否有多语言
export const querySurveyExistMultilLanguage = async (params) => {
  return await axios.post(
    `/v2/feedback/editSurveyImport/querySurveyExistMultilLanguage`,
    params
  )
}

//城市题查询国家列表
export const getTopicDivision = async ({ level, name }) => {
  return await axios.get(
    `/v2/feedback/topic/divisions?divisionName=${name}&divisionLevel=${level}`
  )
}

//城市题查询国家列表
export const getTopicDivisionOuterWifi = async ({
  level,
  name,
  languageCode
}) => {
  return await axios.get(
    `/v2/survey/public/topic-options/divisions?divisionName=${name}&divisionLevel=${level}&languageCode=${languageCode}`
  )
}
